const capitalizeFirstLetter = (
  [first, ...rest]: [string, string],
  locale = navigator.language
) =>
  first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join('')

export default capitalizeFirstLetter
